import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { analyticsBiEvent } from 'analytics/actions'

export const _BIAnalyticsButton = ({ children, dispatchAnalyticsEvent, eventType, expectedEventType }) => {
  if (eventType === expectedEventType) return <div onClick={() => dispatchAnalyticsEvent()}>{children}</div>
  else return children
}

const mapStateToProps = (state, props) => ({
  children: props.children,
  eventType: props.eventType,
  expectedEventType: props.expectedEventType,
})

const mapDispatchToProps = (dispatch) => ({
  dispatchAnalyticsEvent: bindActionCreators(analyticsBiEvent, dispatch),
})

export const WithAnalytics = connect(mapStateToProps, mapDispatchToProps)(_BIAnalyticsButton)
